import { Warehouse } from "../types/warehouse";
import { get, post } from "./fetch.core";

async function add(data: Warehouse) {
  const rst = await post("/admin/warehouse/create", data);

  return rst.data;
}

async function single(id: string) {
  const res = await get<Warehouse>(`/admin/warehouse/single?id=${id}`);
  return res.data;
}

async function deleteRecord(id: string) {
  const res = await post("/admin/warehouse/delete", { id });

  return res.data;
}

async function list() {
  const res = await get<Warehouse[]>("/admin/warehouse/list");

  return res.data;
}

async function update(data: Warehouse) {
  const res = await post("/admin/warehouse/update", data);

  return res.data;
}

async function listPosWarehouse() {
  // as an admin
  const res = await get<Warehouse[]>("/pos/warehouse/list");
  return res.data;
}

const warehouseCore = {
  add,
  single,
  deleteRecord,
  update,
  list,
  listPosWarehouse,
};

export default warehouseCore;
